import { createAsyncThunk } from '@reduxjs/toolkit';
import { users } from 'api/certified-api';
import { errorNotification } from 'utils';

/**
 * @function login
 * @description
 * Thunk asincrónico para manejar el inicio de sesión de usuario utilizando Redux Toolkit.
 * Realiza una solicitud HTTP a la API de autenticación y gestiona errores de forma centralizada.
 *
 * @async
 * @param {Object} credentials - Objeto con las credenciales de inicio de sesión.
 * @param {string} credentials.username - Nombre de usuario.
 * @param {string} credentials.password - Contraseña del usuario.
 * @param {Object} thunkAPI - Proporcionado automáticamente por Redux Toolkit. Permite acceder a dispatch, getState, y rejectWithValue.
 *
 * @returns {Object} Datos del usuario autenticado si es exitoso.
 * @throws {Object} Objeto de error con mensaje y código de estado si la autenticación falla.
 *
 * @example
 * dispatch(login({ username: 'admin', password: '123456' }));
 */

export const login = createAsyncThunk(
    'authetication/login', // Puedes considerar cambiar 'authetication' a 'authentication' para consistencia

    async ({ username, password }, thunkAPI) => {
        try {
            const response = await users.post(`/login`, {
                username,
                password
            });

            if (response.status === 200) {
                const data = response.data.data;
                return data;
            } else {
                // Esto no se ejecutará normalmente con Axios (los errores lanzan excepción)
                return thunkAPI.rejectWithValue({
                    message: response.data.message || 'Unknown error',
                    status: response.status
                });
            }

        } catch (error) {
            console.log(error)
            errorNotification(error.response?.data?.data?.message || error);
            return thunkAPI.rejectWithValue({
                message: error.response?.data?.message || error.message || 'An error occurred',
                status: error.response?.status || 500
            });
        }
    }
);